import { EM } from "resource-planner-model";
import { InviteSaveResult } from "../utils/invitationStatus";
export const FETCH_EMS = "ems/fetch";
export const LOAD_EMS = "ems/load";
export const REMOVE_EM = "ems/remove";
export const REMOVE_EM_LOCAL = "ems/remove_local";
export const PERSIST_EM = "ems/persist";
export const UPSERT_EM = "ems/upsert";
export const SET_EM_JIRA_ACCESS = "ems/jira/access";
export const SET_EM_CONFLUENCE_ACCESS = "ems/confluence/access";

export interface EMsState {
  items: { [id: string]: EM };
  loadedAll: boolean;
  nextToken?: string;
  synching: boolean;
}

export interface FetchEMsAction {
  type: typeof FETCH_EMS;
  append?: boolean;
  limit?: number;
  nextToken?: string;
  paginated?: boolean;
}

export interface LoadEMsAction {
  type: typeof LOAD_EMS;
  append?: boolean;
  items: EM[];
  loadedAll?: boolean;
  nextToken?: string;
}

export interface RemoveEMAction {
  type: typeof REMOVE_EM;
  id: string;
}

export interface RemoveEMLocalAction {
  type: typeof REMOVE_EM_LOCAL;
  id: string;
}

export interface PersistEMAction {
  type: typeof PERSIST_EM;
  item: EM;
}

export type PersistEMResult = InviteSaveResult<EM>;

export interface UpsertEMAction {
  type: typeof UPSERT_EM;
  item: EM;
}

export interface SetEngineerJiraAccessAction {
  type: typeof SET_EM_JIRA_ACCESS;
  id: string;
  callback?: () => void;
}

export interface SetEngineerConfluenceAccessAction {
  type: typeof SET_EM_CONFLUENCE_ACCESS;
  id: string;
  callback?: () => void;
}

export type EMAction =
  | FetchEMsAction
  | LoadEMsAction
  | RemoveEMLocalAction
  | RemoveEMAction
  | PersistEMAction
  | UpsertEMAction
  | SetEngineerJiraAccessAction
  | SetEngineerConfluenceAccessAction;
